<template>
    <div>
        <div class="d-flex align-items-center mb-2">
            <h6 class="mb-0">Commentaires</h6>
            <span class="ms-2 badge bg-secondary">{{ comments.length }}</span>
            <span v-if="loading" class="ms-2 spinner-border spinner-border-sm"></span>
        </div>

        <div v-if="error" class="alert alert-danger py-2">{{ error }}</div>

        <div v-if="!loading && !comments.length" class="text-muted small">
            Aucun commentaire pour le moment.
        </div>

        <ul class="list-group">
            <li v-for="c in comments" :key="c.id" class="list-group-item">
                <div class="d-flex justify-content-end">
                    <div class="small text-muted">
                        {{ $filters.secondDateFormat(c.createdAt) }}
                    </div>
                </div>
                <div class="mt-1" style="white-space: pre-line">{{ c.text }}</div>
            </li>
        </ul>
    </div>
</template>

<script>
import MissionService from '@/services/mission.service';

export default {
    name: 'CommentsList',
    props: {
        missionId: { type: [Number, String], required: true },
    },
    data() {
        return {
            loading: false,
            error: '',
            comments: [],
        };
    },
    mounted() {
        this.fetch();
    },
    methods: {
        async fetch() {
            if (!this.missionId) return;
            try {
                this.loading = true;
                this.error = '';
                const { data } = await MissionService.getMissionComments(this.missionId);
                this.comments = Array.isArray(data) ? [...data].reverse() : [];
            } catch (e) {
                this.error = e?.response?.data?.message || e.message || 'Erreur de chargement';
            } finally {
                this.loading = false;
            }
        },
        reload() {
            return this.fetch();
        },
    },
};
</script>
